import { Route, Routes } from "react-router-dom";

import Login from "./Login";
import Register from "./Register";
import Logout from "./Logout";
import Activate from "./Activate";
import React from "react";
import PasswordResetPage from "./PasswordReset";
import RegistrationSuccess from "./RegistrationSuccess";
import DemoRegister from "./DemoRegister";
import FreemiumRequest from "./FreemiumRequest";

export const PublicAuthRoutes = () => {
  return (
    <Routes>
      <Route path="register" element={<Register />} />
      <Route path="login" element={<Login />} />
      <Route path="logout" element={<Logout />} />
      <Route path="activate/:uid/:token" element={<Activate />} />
      <Route
        path="reset_password/:uid/:token"
        element={<PasswordResetPage />}
      />
      <Route path="register/success" element={<RegistrationSuccess />} />
      <Route path="demo/register" element={<DemoRegister />} />
      <Route
        path="register/free-account-request"
        element={<FreemiumRequest />}
      />
    </Routes>
  );
};

export const LoggedInAuthRoutes = () => {
  return (
    <Routes>
      <Route path="logout" element={<Logout />} />
      <Route path="activate/:uid/:token" element={<Activate />} />
    </Routes>
  );
};
